<template>
  <div class="bottom">
    <downloadBlock
      class="downloadB"
      :downloadInfo="{logo:'iconweidianji1',version:version,text:'Win端下载',downloadUrl:`${this.$api.getBaseUrl()}/api/plugin/video-tool/download-latest`}"
    ></downloadBlock>

    <downloadBlock
      class="downloadB"
      :downloadInfo="{logo:'iconweidianji2',version:version,text:'Mac端下载',downloadUrl:`${this.$api.getBaseUrl()}/api/plugin/video-tool/download-latest`}"
    ></downloadBlock>
  </div>
</template>

<script>
import downloadBlock from "./downloadBlock";
export default {
  components: {
    downloadBlock
  },
  props: {
    versionInfo: {
      type: Array
    }
  },
  computed: {
    version() {
      return this.versionInfo[0].version;
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom {
  width: 100%;
  height: 392px;
  background-image: url("../../../assets/images/website/bottom.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-size: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .downloadB {
    transform: translateY(25px);
    &:first-child {
      margin-right: 80px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/website/components/bottom.vue